import React from "react";
import "./TechnologyStack.scss";

import xcodeIcon from "../../assets/images/icons/xcode.svg";
import androidIcon from "../../assets/images/icons/android.svg";
import appleIcon from "../../assets/images/icons/apple.svg";
import firebaseIcon from "../../assets/images/icons/firebase.svg";
import kotlinIcon from "../../assets/images/icons/kotlin.svg";
import mysqlIcon from "../../assets/images/icons/mysql.svg";
import swiftIcon from "../../assets/images/icons/swift.svg";

const technologies = [
    { name: "Xcode", icon: xcodeIcon },
    { name: "Android", icon: androidIcon },
    { name: "Apple", icon: appleIcon },
    { name: "Firebase", icon: firebaseIcon },
    { name: "Kotlin", icon: kotlinIcon },
    { name: "MySQL", icon: mysqlIcon },
    { name: "Swift", icon: swiftIcon },
];

const TechnologyStack = () => {
    return (
        <section
            className="tech-stack"
            id="tech-stack"
            aria-labelledby="tech-stack-title"
        >
            <div className="tech-stack__inner">
                <div className="tech-stack__header">
                    <p className="tech-stack__eyebrow">Our Technologies</p>

                    <h2 id="tech-stack-title">
                        Technology <span>Stack.</span>
                    </h2>
                </div>

                <ul className="tech-stack__list">
                    {technologies.map((technology) => (
                        <li className="tech-stack__item" key={technology.name}>
                            <div className="tech-stack__icon-box">
                                <img
                                    src={technology.icon}
                                    alt=""
                                    width="40"
                                    height="40"
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>

                            <span className="tech-stack__name">
                {technology.name}
              </span>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default TechnologyStack;